import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import { SelectField, InputField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { VERIFICATION_REPORT_FORM_NAME } from 'Common/FormEnum';
import { VerificationReportFieldEnum as Fields } from 'Common/FieldEnum';
import { ReportEnum } from '../helpers/constants';
import { isNullOrUndefined } from 'util';
import { YesNoOptions } from 'Common/FormHelper';

class VerificationReportFormContainer extends Component {
  reports = () => [
    {
      label: 'Selection Summary',
      value: ReportEnum.SelectionSummary,
      disabled: this.selectionReportsDisabled(),
    },
    {
      label: 'Selection List',
      value: ReportEnum.SelectionList,
      disabled: this.selectionReportsDisabled(),
    },
    {
      label: 'Verification Detail',
      value: ReportEnum.Detail,
      disabled: this.resultsReportsDisabled(),
    },
    {
      label: 'Verification Summary',
      value: ReportEnum.Summary,
      disabled: this.resultsReportsDisabled(),
    },
  ];

  SFATypes = [
    { label: 'Public', value: true },
    { label: 'Nonprofit/Private', value: false },
  ];

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const { formValues, getStatusByFiscalYear } = this.props;
    if (
      !prevProps.formValues ||
      (formValues &&
        prevProps.formValues[Fields.FiscalYear] !==
          formValues[Fields.FiscalYear])
    ) {
      getStatusByFiscalYear(formValues[Fields.FiscalYear]);
    }
  }

  selectionReportsDisabled = () => {
    const { status } = this.props;
    return !status || !status.IsSelected;
  };

  resultsReportsDisabled = () => {
    const { status } = this.props;
    return !status || !status.IsComplete;
  };

  onFiscalYearChange = (e, value) => {
    this.props.change(Fields.SiteCount, this.props.siteCount);
    this.props.change(Fields.Report, ReportEnum.NoReport);
    this.props.getVerificationCollection(value);
  };

  render() {
    const { formValues, loading, fiscalYears } = this.props;

    const fiscalYearOptions =
      fiscalYears && fiscalYears.length > 0
        ? fiscalYears.map((fiscalYear, i) => ({
            value: fiscalYear,
            key: i,
            text: fiscalYear,
          }))
        : [];

    return (
      <Fragment>
        <Form name={VERIFICATION_REPORT_FORM_NAME}>
          <TitledCard title={'Report Settings'}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Field
                    name={Fields.FiscalYear}
                    component={SelectField}
                    type="text"
                    label="Fiscal Year"
                    options={fiscalYearOptions}
                    disabled={loading}
                    onChange={this.onFiscalYearChange}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3}>
                  {formValues &&
                  formValues[Fields.FiscalYear] === fiscalYears[0] ? (
                    <Field
                      name={Fields.SiteCount}
                      component={InputField}
                      type="number"
                      label="Site Count"
                      disabled={loading}
                      min={1}
                    />
                  ) : (
                    undefined
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column className="input-group--btn-group">
                  <ReduxFormButtonGroup
                    label={'Choose Report'}
                    options={this.reports()}
                    formName={VERIFICATION_REPORT_FORM_NAME}
                    value={formValues ? formValues[Fields.Report] : null}
                    fieldName={Fields.Report}
                    disabled={loading}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {formValues &&
            formValues[Fields.Report] === ReportEnum.Summary &&
            formValues[Fields.FiscalYear] === fiscalYears[0] ? (
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <label className={'text-orange'}>
                      Verification Collection
                    </label>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={5}>
                    <Field
                      name={Fields.StateAgencyName}
                      component={InputField}
                      label={'State Agency Name'}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={5} className="input-group--btn-group">
                    <ReduxFormButtonGroup
                      label={'Type of SFA'}
                      options={this.SFATypes}
                      formName={VERIFICATION_REPORT_FORM_NAME}
                      value={formValues ? formValues[Fields.SFAIsPublic] : null}
                      fieldName={Fields.SFAIsPublic}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column width={3}>
                    <Field
                      name={Fields.SFACity}
                      component={InputField}
                      label={'SFA City'}
                      disabled={loading}
                    />
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Field
                      name={Fields.SFAZip}
                      component={InputField}
                      label={'SFA Zip'}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column className="input-group--btn-group">
                    <ReduxFormButtonGroup
                      label={
                        '3-1: All schools and/or RCCIs in the SFA were not required to perform direct certification with SNAP (i.e. NON BASE year Provision 2/3 for all schools)'
                      }
                      options={YesNoOptions}
                      formName={VERIFICATION_REPORT_FORM_NAME}
                      value={formValues[Fields.SchoolsNotRequired]}
                      fieldName={Fields.SchoolsNotRequired}
                      disabled={loading}
                    />
                  </Grid.Column>
                  <Grid.Column className="input-group--btn-group">
                    <ReduxFormButtonGroup
                      label={'5-2: Was verification performed and completed?'}
                      options={YesNoOptions}
                      formName={VERIFICATION_REPORT_FORM_NAME}
                      value={formValues[Fields.VerificationCompleted]}
                      fieldName={Fields.VerificationCompleted}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column className="input-group--btn-group">
                    <ReduxFormButtonGroup
                      label={
                        '5-1: All schools and/or RCCIs are exempt from Verification'
                      }
                      options={YesNoOptions}
                      formName={VERIFICATION_REPORT_FORM_NAME}
                      value={formValues[Fields.SchoolsExempt]}
                      fieldName={Fields.SchoolsExempt}
                      disabled={loading}
                    />
                  </Grid.Column>
                  <Grid.Column className="input-group--btn-group">
                    <ReduxFormButtonGroup
                      label={'Was verification completed by November 15th?'}
                      options={YesNoOptions}
                      formName={VERIFICATION_REPORT_FORM_NAME}
                      value={formValues[Fields.VerificationCompletedByNov15]}
                      fieldName={Fields.VerificationCompletedByNov15}
                      disabled={
                        loading || !formValues[Fields.VerificationCompleted]
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            ) : (
              undefined
            )}
          </TitledCard>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values[Fields.FiscalYear]) {
    errors[Fields.FiscalYear] = 'Fiscal Year must be set.';
  }

  if (isNullOrUndefined(values[Fields.SiteCount])) {
    errors[Fields.SiteCount] = 'Site Count must be set.';
  }

  if (
    isNullOrUndefined(values[Fields.Report]) ||
    values[Fields.Report] === ReportEnum.NoReport
  ) {
    errors[Fields.Report] = 'Report must be set.';
  }

  if (values[Fields.Report] === ReportEnum.Summary) {
    if (isNullOrUndefined(values[Fields.StateAgencyName])) {
      errors[Fields.StateAgencyName] = 'State Agency Name must be set.';
    }
    if (isNullOrUndefined(values[Fields.SFAIsPublic])) {
      errors[Fields.SFAIsPublic] = 'SFA Type must be set.';
    }
    if (isNullOrUndefined(values[Fields.SFACity])) {
      errors[Fields.SFACity] = 'SFA City must be set.';
    }
    if (isNullOrUndefined(values[Fields.SFAZip])) {
      errors[Fields.SFAZip] = 'SFA Zip must be set.';
    }
  }

  return errors;
};

const VerificationReportForm = reduxForm({
  form: VERIFICATION_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
})(withRouter(VerificationReportFormContainer));

export { VerificationReportForm };



// WEBPACK FOOTER //
// ./src/pages/verificationreport/components/VerificationReportForm.js